import { useModalStore } from "store/modal/hooks/useModalStore";

import { Button } from "@krea/shared/design-system/Button";
import { AppModal } from "@krea/shared/design-system/modal";

import { useDeleteBid } from "@/features/lender-responses/hooks/data/use-delete-bid.mutation";

export const DeleteBidModal = () => {
  const modalParams = useModalStore((state) =>
    state.modalParams?.type === "deleteBid" ? state.modalParams.params : null,
  );

  const {
    loading: isModalLoading,
    closeModal,
    setModalLoading,
  } = useModalStore((state) => ({
    loading: state.loading,
    closeModal: state.closeModal,
    setModalLoading: state.setModalLoading,
  }));

  const onCloseModal = () => {
    closeModal();
  };

  const { mutate: deleteBid } = useDeleteBid();

  const onSubmit = () => {
    if (!modalParams) return;
    setModalLoading(true);
    deleteBid(
      {
        lenderCompanyId: modalParams.lenderCompanyId,
        lenderApplicationId: modalParams.lenderApplicationId,
        lenderResponseId: modalParams.lenderResponseId,
      },
      {
        onSuccess: () => {
          setModalLoading(false);
          closeModal();
        },
      },
    );
  };

  if (!modalParams) return null;

  return (
    <AppModal
      open={true}
      setOpen={(open) => {
        if (!open) onCloseModal();
      }}
      onClose={onCloseModal}
      title="Remove bid"
      footer={
        <>
          <Button variant="secondary" onClick={onCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onSubmit} disabled={isModalLoading}>
            Remove
          </Button>
        </>
      }
    >
      <h5 className="mb-3">Are you sure you want to remove this bid?</h5>
    </AppModal>
  );
};
